module.exports = __webpack_public_path__ + "img/adieu-xrp.24ad4b19.png";